import {useRef} from "react"
import Text from "../../components/input/text";
import UseGetFormData from "../../hooks/UseGetFormData";
import {Col, Row} from "react-bootstrap";
import Button from "../../components/button";
import Preloader from "../../components/preloader";


const Form = (props) => {
    const {fields, entity, errors, isReady, onSubmit} = props
    const formRef = useRef()

    const system_fields = [
        'first_name', 'last_name', 'phone_number',
        'mobile_phone', 'email_address'
    ]

    const handleSubmit = (ev) => {
        ev.preventDefault()
        const ObjectData = {}
        const FormData = UseGetFormData(formRef)

        fields?.length > 0 && fields.map((field) => {
            ObjectData[field.value] = FormData.get(field.value)
        })

        onSubmit(ObjectData)
    }


    return (
        <form autoComplete="off" ref={formRef} onSubmit={handleSubmit}>
            <div className="max-width-650">
                <Preloader maskOnly isReady={isReady} />
                <>
                    <h6 className="mt-3 mb-0">Edit Entity</h6>
                    <p className="mb-4">The fields below are the same fields you defined in the fields tab</p>
                    <Row>
                        {system_fields.map((field) =>{
                            return <Col key={`key_${field}`} sm={6}>
                                <Text
                                    isReady={isReady}
                                    name={field}
                                    className="user-field"
                                    placeholder="Type mobile phone..."
                                    label={field.replace('_', ' ')}
                                    error={errors && errors[field]}
                                    value={entity && entity[field]}
                                />
                            </Col>
                        })}

                        {fields?.length > 0 && fields.map((field) => {
                            if(!system_fields.includes(field.value)){
                                return <Col key={`key_${field.value}`} sm={6}>
                                    <Text
                                        isReady={isReady}
                                        name={field.value}
                                        className="user-field"
                                        placeholder="Type mobile phone..."
                                        label={field.value.replace('_', ' ')}
                                        error={errors && errors[field.value]}
                                        value={entity && entity[field.value]}
                                    />
                                </Col>
                            }
                        })}
                    </Row>
                </>
            </div>
            <Button
                size="sm"
                color="primary"
                isReady={true}
                className="mt-3"
                icon={entity ? 'check' : 'plus'}
                label={entity ? 'Update' : 'Create'}
            />
        </form>
    )
}

export default Form